import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4342e856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PreTripDetails" }
const _hoisted_2 = {
  key: 0,
  class: "PreTripDetails__state"
}
const _hoisted_3 = {
  key: 1,
  class: "text-red-500 text-sm"
}
const _hoisted_4 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_5 = {
  key: 1,
  class: "PreTripDetails__content"
}
const _hoisted_6 = { class: "content__direction" }
const _hoisted_7 = { class: "direction__title" }
const _hoisted_8 = { class: "content__information" }
const _hoisted_9 = { class: "information__row" }
const _hoisted_10 = { class: "information__container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Дата", -1))
const _hoisted_12 = { class: "container__value" }
const _hoisted_13 = { class: "information__container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Перенесен с:", -1))
const _hoisted_15 = {
  key: 1,
  class: "container__value"
}
const _hoisted_16 = { class: "information__row" }
const _hoisted_17 = { class: "information__container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Тип авто", -1))
const _hoisted_19 = { class: "container__value" }
const _hoisted_20 = { class: "information__container" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Комментарий", -1))
const _hoisted_22 = { class: "container__value" }
const _hoisted_23 = { class: "information__row" }
const _hoisted_24 = { class: "information__container" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Есть заявка:", -1))
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "information__container" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Есть рейс:", -1))
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "information__row" }
const _hoisted_32 = { class: "information__container" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Общий вес", -1))
const _hoisted_34 = { class: "container__value" }
const _hoisted_35 = { class: "information__container" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__placeholder" }, "Общий объем", -1))
const _hoisted_37 = { class: "container__value" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_39 = {
  key: 0,
  class: "content__ttns"
}
const _hoisted_40 = {
  key: 1,
  class: "content__reschedule"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_pre_trip_status = _resolveComponent("pre-trip-status")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_pre_trip_details_ttn = _resolveComponent("pre-trip-details-ttn")!
  const _component_reschedule_history_item = _resolveComponent("reschedule-history-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.details)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createBlock(_component_loader, {
                key: 0,
                class: "primary text-2xl"
              }))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " При получении данных произошла ошибка "))
              : (!_ctx.state.details)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.state.details.direction.fromCity.name) + " - " + _toDisplayString(_ctx.state.details.direction.whereCity.name), 1),
            _createVNode(_component_pre_trip_status, {
              status: _ctx.state.details.status
            }, null, 8, ["status"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.state.details.date)), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (Boolean(_ctx.state.details.parentId))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      class: "container__value value--link",
                      target: "_blank",
                      to: `/tms/graph?id=${_ctx.state.details.parentId}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isProdVersion
                                    ? 'https://bpms.spark.kz'
                                    : 'https://bpms.spark-dev.team') + "/tms/graph?id=" + _toDisplayString(_ctx.state.details.parentId), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, "-"))
              ])
            ]),
            _createVNode(_component_new_button, {
              type: "button",
              onClick: _ctx.onTransfer
            }, {
              default: _withCtx(() => [
                _createTextVNode("Перенести предрейс")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  (_ctx.state.details.car)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.details.car.title), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.state.details.comment)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.details.comment.name), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                (_ctx.state.details.bidId)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/bids/new/${_ctx.state.details.bidId}`,
                      class: "text-blue-500",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Заявка ID: " + _toDisplayString(_ctx.state.details.bidId), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.state.details.tripId)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/tms/trips/${_ctx.state.details.tripId}`,
                        class: "text-blue-500",
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Рейс ID: " + _toDisplayString(_ctx.state.details.tripId), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, "-")),
                  (_ctx.state.details.tripStatus)
                    ? (_openBlock(), _createBlock(_component_pre_trip_status, {
                        key: 2,
                        class: "ml-3",
                        status: _ctx.state.details.tripStatus
                      }, null, 8, ["status"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.state.details.totalWeight) + " кг", 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createTextVNode(_toDisplayString(_ctx.state.details.totalCubature) + " м", 1),
                  _hoisted_38
                ])
              ])
            ])
          ]),
          (_ctx.state.details.ttns && _ctx.state.details.ttns.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.details.ttns, (ttn) => {
                  return (_openBlock(), _createBlock(_component_pre_trip_details_ttn, {
                    key: ttn.id,
                    ttn: ttn
                  }, null, 8, ["ttn"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.details.rescheduleHistory.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.details.rescheduleHistory, (item, i) => {
                  return (_openBlock(), _createBlock(_component_reschedule_history_item, {
                    key: `reschedule-item-${i}`,
                    item: item,
                    onUpdateComment: _ctx.onUpdateComment
                  }, null, 8, ["item", "onUpdateComment"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}